  import React from "react";
  import "./ProductoLabel.css";

  export default function CampoTexto({
    etiqueta,
    valor,
    onChange,
    tipo = "text",
    placeholder = "",
    editable = true,
    align = "center",
    formato = null, 
  }) {
    // Aplica formato si viene definida una función (por ejemplo: formatear moneda)
    const displayValue =
      typeof formato === "function" ? formato(valor) : valor ?? "";

    return (
      <div className="campo-texto">
        {etiqueta && <div className="campo-etiqueta">{etiqueta}</div>}

        <div className={`campo-entrada align-${align}`}>
          {editable ? (
            <input
              type={tipo}
              value={valor}
              placeholder={placeholder}
              onChange={(e) => onChange && onChange(e.target.value)}
              className="campo-input"
            />
          ) : (
            <div className="campo-valor">{displayValue}</div>
          )}
        </div>
      </div>
    );
  }
